import React from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ImageInput,
  ImageField,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

// ---------- CREATE ----------
export const GameCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" />
      <TextInput source="slug" label="Slug" />

      <ReferenceInput source="category" reference="categories" label="Category">
        <SelectInput optionText="name" />
      </ReferenceInput>

      <ImageInput source="image" label="Image" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="game_url" label="Game url" />

      <BooleanInput source="is_hot" label="Is hot" defaultValue={false} />
      <BooleanInput source="is_featured" label="Is featured" defaultValue={false} />
      <BooleanInput source="is_active" label="Is active" defaultValue={true} />

      <NumberInput source="sort_order" label="Sort order" defaultValue={0} />
    </SimpleForm>
  </Create>
);

// ---------- EDIT ----------
const formatImage = (value) => {
  if (!value) return value;
  if (typeof value === 'string') {
    return { src: value, title: value };
  }
  return value;
};

const parseImage = (value) => {
  if (!value) return null;
  if (value.rawFile) return value;
  return value.src;
};

export const GameEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" />
      <TextInput source="slug" label="Slug" />

      <ReferenceInput source="category" reference="categories" label="Category">
        <SelectInput optionText="name" />
      </ReferenceInput>

      <ImageInput
        source="image"
        label="Image"
        accept="image/*"
        format={formatImage}
        parse={parseImage}
      >
        <ImageField source="src" title="title" />
      </ImageInput>

      <TextInput source="game_url" label="Game url" />

      <BooleanInput source="is_hot" label="Is hot" />
      <BooleanInput source="is_featured" label="Is featured" />
      <BooleanInput source="is_active" label="Is active" />

      <NumberInput source="sort_order" label="Sort order" />
    </SimpleForm>
  </Edit>
);